/**
 * Created by intellicar-rinas on 4/10/17.
 */
import $http from '../helpers/$http';
import {API_HOST} from '../constants/constants';
import apiHelper from '../helpers/apiHelper';
import axios from 'axios';

const ReportAPIs = {

    getAddress: (body,schema) => {

        let limit = 300;
        let counter = 0;
        let reqArray = [];
        let tempBody = [];

        for(let idx in body){
            tempBody.push(body[idx]);
            counter++;
            if(counter >= limit){
                reqArray.push($http.post(API_HOST + '/api/address/getaddressfortrack', {data: tempBody}));
                tempBody = [];
                counter = 0;
            }
        }

        if(tempBody.length){
            reqArray.push($http.post(API_HOST + '/api/address/getaddressfortrack', {data: tempBody}));
        }


        const handleSuccess = function (resp) {
            if (window.setReportWindowTabBusy && schema)
                window.setReportWindowTabBusy(schema, false);
            let resultArray = [];
            for(let idx in resp){
                for(let jdx in resp[idx].data.data){
                    resultArray.push(resp[idx].data.data[jdx]);
                }
            }
            return resultArray;
        };

        return axios.all(reqArray)
            .then(handleSuccess,()=>{
                // if (window.setReportWindowTabBusy)
                //     window.setReportWindowTabBusy(schema, false);
            });
    },
    getMapAddress: (body, uid) => {
        return $http.post(API_HOST + '/api/address/getaddress', body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },
    GetGeoLoc: (body, uid) => {
        return $http.post(API_HOST + '/api/v1/geoloc/location/batch', body, {}, uid)
            .then(apiHelper.validateResponse, apiHelper.validateFailure)
    },

};


export default ReportAPIs;
